import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import FilterContainer from "../FilterContainer";
import { IFilterProps } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import FilterRadios from "../FilterRadios";
import moment from "moment";
import FilterList from "../FilterList";
import { BANNER_FEED_POSTION_OPTIONS } from "../../../../utils/ui.constants";

const trangThais: { label: string; value: string }[] = [
  {
    label: "Tất cả",
    value: "all",
  },
  {
    label: "Hiển thị",
    value: "show",
  },
  {
    label: "Ẩn",
    value: "hide",
  },
];
const expires: { label: string; value: string }[] = [
  {
    label: "Tất cả",
    value: "all",
  },
  {
    label: "Chưa đến ngày",
    value: "waiting",
  },
  {
    label: "Còn hiệu lực",
    value: "running",
  },
  {
    label: "Hết hiệu lực",
    value: "expire",
  },
];

function FilterBannerFeed({ setCondition }: IFilterProps) {
  const originFilter: { [key: string]: any } = {
    tieu_de: "",
    status: "all",
    expire: "all",
    positions: [],
    timeFrom: null,
    timeTo: moment().toISOString(),
  };
  const [filter, setFilter] = useState(originFilter);

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.tieu_de) {
      condition.tieu_de = {
        $regex: filter.tieu_de?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.positions?.length > 0) {
      condition["exfields.position"] = { $in: filter.positions };
    }
    switch (filter.status) {
      case "hide":
        condition.status = false;
        break;
      case "show":
        condition.status = true;
        break;
      default:
        break;
    }
    const today = moment().endOf("days").toISOString();
    switch (filter.expire) {
      case "expire":
        condition["exfields.end_date"] = { $lt: today };
        break;
      case "waiting":
        condition["exfields.start_date"] = { $gt: today };
        break;
      case "running":
        condition.$or.push({
          "exfields.start_date": { $in: ["", null] },
          "exfields.end_date": { $in: ["", null] },
        });
        condition.$or.push({
          "exfields.start_date": { $lte: today },
          "exfields.end_date": { $gte: today },
        });
        break;
      default:
        break;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <FilterContainer handleRefreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} gap={1}>
        <FilterText
          title="Tiêu đề"
          placeholder="Tìm theo tên tiêu đề"
          value={filter.tieu_de}
          onSearch={(value) => setFilter({ ...filter, tieu_de: value })}
        />
        <FilterList
          title="Vị trí"
          items={BANNER_FEED_POSTION_OPTIONS}
          defaultValues={filter.positions}
          onChange={(value) =>
            setFilter((prev) => {
              return { ...prev, positions: value };
            })
          }
        />
        <FilterRadios
          title="Trạng thái"
          values={trangThais}
          defaultValue={filter.status}
          onChange={(val) => setFilter({ ...filter, status: val })}
        />
        <FilterRadios
          title="Thời gian"
          values={expires}
          defaultValue={filter.expire}
          onChange={(val) => setFilter({ ...filter, expire: val })}
        />
      </Stack>
    </FilterContainer>
  );
}

export default FilterBannerFeed;
